import {
  createDomainApi,
  type ExtractEntityType,
  type ExtractInputType,
} from '@skylabs-digital/react-proto-kit';
import { rateLimitInputSchema, rateLimitSchema } from '../schemas/rateLimit.schema';

export const rateLimitsApi = createDomainApi('rate-limits', rateLimitSchema, rateLimitInputSchema);

export type RateLimitEntity = ExtractEntityType<typeof rateLimitsApi>;
export type RateLimitInputType = ExtractInputType<typeof rateLimitsApi>;
